import React, { useState } from "react";
import AboutHeader from "../../components/aboutHeader/aboutHeader";
import Alert from "../../components/alert/alert";
import SideBarNav from "../../components/sideBarNav/sideBarNav";
import { auth, firestore } from "../../db/config";
import "../register/register.css";
export default function Login() {
  const [alertMessage, setalertMessage] = useState({
    message: "",
    loader: false,
    status: "",
    buttonStatus: false,
  });
  const [setValues, setsetValues] = useState({
    email: "",
    password: "",
  });
  const handleChange = (value, attr) => {
    setsetValues({
      ...setValues,
      [attr]: value,
    });
  };
  const handleClick = () => {
    setalertMessage({
      loader: true,
    });
    if (setValues.email === "" || setValues.password === "") {
      setalertMessage({
        message: "Please fill out all empty fields",
        status: "danger",
        loader: false,
        buttonStatus: false,
      });
    } else {
      auth
        .signInWithEmailAndPassword(setValues.email, setValues.password)
        .then(() => {
          window.location.href = "/my_account";
        })
        .catch((error) => {
          setalertMessage({
            message: error.message,
            status: "danger",
            loader: false,
            buttonStatus: false,
          });
        });
    }
  };
  return (
    <div>
      <AboutHeader />

      <div class="page_title_section">
        <div class="page_header">
          <div class="container">
            <div class="row">
              <div class="col-lg-9 col-md-9 col-12 col-sm-8">
                <h1>login</h1>
              </div>
              <div class="col-lg-3 col-md-3 col-12 col-sm-4">
                <div class="sub_title_section">
                  <ul class="sub_title">
                    <li>
                      {" "}
                      <a href="/"> Home </a>&nbsp; / &nbsp;{" "}
                    </li>
                    <li>login</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="login_wrapper fixed_portion float_left">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="login_top_box float_left">
                <div class="login_banner_wrapper">
                  {/* <img src="images/logo2.png" alt="logo"/> */}
                  <div>Treasure Growth Investment</div>
                  <div class="about_btn  facebook_wrap float_left">
                    {/* <a href="#">
                      login with facebook <i class="fab fa-facebook-f"></i>
                    </a> */}
                  </div>
                  <div class="about_btn google_wrap float_left">
                    {/* <a href="#">
                      login with pinterest <i class="fab fa-pinterest-p"></i>
                    </a> */}
                  </div>
                  <div class="jp_regis_center_tag_wrapper jb_register_red_or">
                    <h1>OR</h1>
                  </div>
                </div>
                <div class="login_form_wrapper">
                  <div class="sv_heading_wraper heading_wrapper_dark dark_heading hwd">
                    <h3> login to enter</h3>
                  </div>
                  <div class="form-group icon_form comments_form">
                    <input
                      type="text"
                      class="form-control require"
                      name="full_name"
                      placeholder="Email Address*"
                      onChange={(evt) =>
                        handleChange(evt.target.value, "email")
                      }
                    />
                  </div>
                  <div class="form-group icon_form comments_form">
                    <input
                      type="password"
                      class="form-control require"
                      placeholder="Password *"
                      onChange={(evt) =>
                        handleChange(evt.target.value, "password")
                      }
                    />
                  </div>
                  <div class="login_remember_box">
                    {/* <label class="control control--checkbox">
                      Remember me
                      <input type="checkbox" />
                      <span class="control__indicator"></span>
                    </label> */}
                    <a href="#" class="forget_password">
                      Forgot Password
                    </a>
                  </div>
                  {alertMessage.message ? (
                    <Alert details={{ ...alertMessage }} />
                  ) : (
                    ""
                  )}
                  {alertMessage.loader ? (
                    <div class="about_btn login_btn float_left">
                      <a className="register__button">Please wait...</a>
                    </div>
                  ) : (
                    <div
                      class="about_btn login_btn float_left"
                      onClick={handleClick}
                    >
                      <a className="register__button">login</a>
                    </div>
                  )}

                  <div class="dont_have_account float_left">
                    <p>
                      Don’t have an acount ? <a href="/register">Sign up</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
